export enum ActionType {
  createAsset = 'createAsset',
  mergeAsset = 'mergeAsset',
  associateAssetWithDevice = 'associateAssetWithDevice'
}

export enum DataType {
  animals = 'animals',
  deviceAssociations = 'deviceAssociations',
  devices = 'devices',
  farms = 'farms',
  fixedSamplePoints = 'fixedSamplePoints',
  loRaGateways = 'loRaGateways',
  paddocks = 'paddocks',
  precipitationSamplePoints = 'precipitationSamplePoints',
  proximitySamplePoints = 'proximitySamplePoints',
  waterPoints = 'waterPoints',
}

export interface TokenWrapper {
  token: string;
}

export interface DateWrapper {
  date: string;
}
